import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store';
import ant from 'ant-design-vue';

import 'uno.css'
import '@/assets/styles/views/app.less';
import '@/assets/styles/base/global.less';
import 'ant-design-vue/dist/reset.css';

import $ from 'jquery';

window.$ = window.jQuery = $;
const app = createApp(App);
app.config.globalProperties.window = window;

app.use(router).use(store).use(ant).mount('#app');
